document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".article-shell").forEach((shell) => {
    const headings = [...shell.querySelectorAll(".article-shell-main .prose-block h2[id]")]
    const links = [...shell.querySelectorAll(".article-toc a")]
    const drawer = shell.querySelector(".article-toc-mobile")
    if (!headings.length) return

    const setCurrent = (id) => {
      links.forEach((link) => {
        if (link.getAttribute("href") === `#${id}`) {
          link.setAttribute("aria-current", "true")
        } else {
          link.removeAttribute("aria-current")
        }
      })
    }

    const offset = () => {
      const style = getComputedStyle(shell)
      return parseFloat(style.getPropertyValue("--nav-h")) +
        parseFloat(style.getPropertyValue("--toc-mobile-h")) + 12
    }

    const activeBoundary = () => Math.min(offset() + 80, window.innerHeight)
    const updateCurrent = () => {
      const current = headings.filter((heading) => heading.getBoundingClientRect().top <= activeBoundary()).at(-1)
      setCurrent(current?.id)
    }

    let frame
    const requestUpdate = () => {
      if (frame) return
      frame = requestAnimationFrame(() => {
        frame = undefined
        updateCurrent()
      })
    }

    let observer
    const observe = () => {
      observer?.disconnect()
      const top = offset()
      const bottom = Math.max(window.innerHeight - top - 80, 0)
      observer = new IntersectionObserver(requestUpdate, { rootMargin: `-${top}px 0px -${bottom}px 0px` })
      headings.forEach((heading) => observer.observe(heading))
      requestUpdate()
    }
    observe()
    window.addEventListener("resize", observe)
    window.addEventListener("scroll", requestUpdate, { passive: true })

    drawer?.querySelector(".article-toc")?.addEventListener("click", (event) => {
      if (event.target.closest("a[href^='#']") && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        drawer.open = false
      }
    })
  })
})
